import { Fragment, useSyncExternalStore } from "react";

export type Language = "de" | "en";

const LANGUAGES: { label: string; language: Language }[] = [
  { label: "DE", language: "de" },
  { label: "EN", language: "en" },
];

const linkClass = (active: boolean) =>
  `text-body-2 px-2xs py-2xs rounded-s transition-colors no-underline ${
    active
      ? "text-neutral-675 font-semibold hover:bg-neutral-12"
      : "text-neutral-425 font-book hover:text-primary-800 hover:bg-neutral-12"
  }`;

const subscribeToLocation = (onLocationChange: () => void) => {
  window.addEventListener("hashchange", onLocationChange);
  window.addEventListener("popstate", onLocationChange);

  return () => {
    window.removeEventListener("hashchange", onLocationChange);
    window.removeEventListener("popstate", onLocationChange);
  };
};

const getSearch = () => window.location.search;

const getHash = () => window.location.hash;

const getServerLocationPart = () => "";

const LanguageLinks = ({
  language,
  alternateLanguageHref,
}: {
  language: Language;
  alternateLanguageHref: string | null;
}) => {
  const search = useSyncExternalStore(
    subscribeToLocation,
    getSearch,
    getServerLocationPart,
  );
  const hash = useSyncExternalStore(
    subscribeToLocation,
    getHash,
    getServerLocationPart,
  );
  const query = /[?#]/.test(alternateLanguageHref ?? "") ? "" : search;
  const fragment = alternateLanguageHref?.includes("#") ? "" : hash;

  const href = alternateLanguageHref
    ? `${alternateLanguageHref}${query}${fragment}`
    : null;

  return (
    <div className="flex items-center ml-3xs">
      {LANGUAGES.map((entry, index) => (
        <Fragment key={entry.label}>
          {index > 0 && (
            <span
              className="w-[1px] h-[14px] bg-neutral-50"
              aria-hidden="true"
            />
          )}
          {entry.language === language ? (
            <span className={linkClass(true)} aria-current="true">
              {entry.label}
            </span>
          ) : href ? (
            <a className={linkClass(false)} href={href}>
              {entry.label}
            </a>
          ) : (
            <span
              className="text-body-2 px-2xs py-2xs rounded-s text-neutral-425 font-book cursor-not-allowed"
              aria-disabled="true"
              aria-label={
                language === "de"
                  ? "Englische Übersetzung nicht verfügbar"
                  : "German translation unavailable"
              }
            >
              {entry.label}
            </span>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default LanguageLinks;
